import { SVGProps } from 'react';

export const EmailIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    {...props}
    aria-hidden="true"
    width="22"
    height="15"
    viewBox="0 0 22 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.56 7.72926L19.4395 1.81918H2.56054L10.44 7.72926L10.4403 7.72947C10.5738 7.83106 10.7833 7.89715 10.9998 7.89617L11.0003 7.89617C11.2168 7.89715 11.4262 7.83107 11.5598 7.72946L11.56 7.72926ZM2.41778 13.5142H19.5822L15.2775 8.19662L15.2775 8.1966C15.1266 8.01003 15.1552 7.73648 15.3421 7.58523L15.3421 7.58523C15.5287 7.43435 15.8022 7.4629 15.9532 7.64956C15.9532 7.64956 15.9532 7.64957 15.9532 7.64957L20.1808 12.8719V2.34996L12.0813 8.42457L12.0812 8.42467C11.7637 8.66116 11.3786 8.76431 11.0002 8.76535L11 8.76535C10.622 8.76455 10.2367 8.66139 9.91895 8.42466L9.91883 8.42457L1.81937 2.34996V12.8718L6.04679 7.64957C6.19777 7.46297 6.47158 7.43427 6.65792 7.58525C6.8448 7.73621 6.87343 8.01008 6.72246 8.19661L6.68359 8.16516L6.72246 8.19662L2.41778 13.5142ZM2.02566 0.95H19.9743C20.5661 0.95 21.05 1.43391 21.05 2.02562V13.3077C21.05 13.8994 20.5661 14.3834 19.9743 14.3834H2.02563C1.43395 14.3834 0.949963 13.8995 0.949963 13.3077V2.02562C0.950003 1.43391 1.43391 0.95 2.02566 0.95Z"
      fill="currentcolor"
      stroke="#999999"
      strokeWidth="0.1"
    />
  </svg>
);
